const Env = {
  ENV_NAME: process.env.EXPO_PUBLIC_ENV_NAME,
  CREDSYSTEM_SSO: process.env.EXPO_PUBLIC_CREDSYSTEM_SSO,
  CREDSYSTEM_API: process.env.EXPO_PUBLIC_CREDSYSTEM_API,
  CREDSYSTEM_CLIENT_SESSION_API:
    process.env.EXPO_PUBLIC_CREDSYSTEM_CLIENT_SESSION_API,
  CREDSYSTEM_CLIENT_SECRET: process.env.EXPO_PUBLIC_CREDSYSTEM_CLIENT_SECRET,
  CREDSYSTEM_SERVICE_ACCOUNT:
    process.env.EXPO_PUBLIC_CREDSYSTEM_SERVICE_ACCOUNT,
};

export default Env;
